import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('REQUESTS_FOR_PROPOSAL');
export const REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	REQUESTS_FOR_PROPOSAL_CRUD_ACTION_CONSTANTS
);
